import contentGridStyles from './content-grid';

var filterButton = document.getElementById('contentFilterToggle');
var filterButtonText = document.getElementById('contentFilterText');
var filterButtonArrow = document.getElementById('contentFilterArrowWrapper');
var filterMenu = document.getElementById('contentFilterMenu');
var filterMenuItems = document.querySelectorAll('.content-grid__filter-menu-item');
if (filterButton !== null || undefined) {
		setupDropDown()
}
function setupDropDown() {
	for (let i = 0; i < filterMenuItems.length; i++) {
		filterMenuItems[i].addEventListener('click', () => { filterItemSelected(filterMenuItems[i]) }, !1)
	}
}
function filterItemSelected(item) {
	console.log("item"); filterButtonText.textContent = item.textContent; updateGrid(item.attributes['data-value'].value); for (let i = 0; i < filterMenuItems.length; i++) { filterMenuItems[i].classList.remove('hideItem') } item.classList.add('hideItem'); closeFilterMenu()
}
function updateGrid(value) {
	let gridItems = document.querySelectorAll('.content-grid__item');
	if (value === 'all') {
		for (let i = 0; i < gridItems.length; i++) {
			gridItems[i].classList.remove('hideItem')
		}
	} else {
		for (let i = 0; i < gridItems.length; i++) {
			if (gridItems[i].getAttribute('data-category-id') === value) {
				gridItems[i].classList.remove('hideItem')
			} else {
				gridItems[i].classList.add('hideItem')
			}
		}
	}
}
function filterButtonToggle() {
	filterMenu.classList.toggle('active'); filterButtonArrow.classList.toggle('open')
}
function closeFilterMenu() {
	if (filterMenu.classList.contains('active')) {
		filterMenu.classList.remove('active'); filterButtonArrow.classList.remove('open')
	}
}
